// extracted by css-extract-rspack-plugin
export default {"swatch":"LabelColumnHeader-module__swatch__olanJ"};